import { AddressType } from 'src/app/models/type/address.type.enum';

export class AddressName {
  subdistrictName?: string; // ตำบล หรือ แขวง
  districtName?: string; // อำเภอ หรือ เขต
  provinceName?: string; // จังหวัด
}

export class Address extends AddressName {
  addressId?: number;
  type: AddressType;
  address?: string; // บ้านเลขที่, ทับ, หมู่บ้าน, หมู่บ้านเลขที่, ชั้น, อาคาร, ถนน, ซอย
  houseNumber?: string | number; // บ้านเลขที่
  villageNo?: string | number; // หมู่บ้านเลขที่
  floor?: string | number; // ชั้น
  building?: string; // อาคาร
  road?: string; // ถนน
  soi?: string; // ซอย
  subdistrict?: string; // ตำบล หรือ แขวง
  district?: string; // อำเภอ หรือ เขต
  province?: string; // จังหวัด
  postalCode?: string; // รหัสไปรษณีย์
  country?: string; // ประเทศ
  fullAddress?: string;
}
